<template>
  <div class="top-warp">
    <div class="dilemma-box">
      <div class="top-title">我们如何助力企业<br/>轻松应对税务难题
        <div class="bgDot-box">
          <hm-img type="icons" imgName="bg_dot" imgClass="bgDot"/>
        </div>
      </div>
      <div>
        <a-row>
          <a-col :span="24">
            <hm-img type="images" imgName="dilemma01" imgClass="introduction_img_style" align="right"/>
          </a-col>
          <a-col :span="24" class="info-box">
            <h1 class="info-title">降低财税运营成本</h1>
            <div class="introduce_info">
              <div class="QAIcon">
                <hm-img type="icons" imgName="Q" imgClass="QAImg"/>
              </div>
              <p>税收政策频繁变动、税务判断复杂，企业需持续投入人力应对，导致税务运营成本持续高企</p>
            </div>
            <a-divider />
            <div class="introduce_info">
              <div class="QAIcon">
                <hm-img type="icons" imgName="A" imgClass="QAImg"/>
              </div>
              <p>税纪云为企业提供业财票税全流程融合的一站式产品及解决方案，帮助企业提升税务管理的标准化及自动化程度</p>
            </div>
          </a-col>
        </a-row>
          <!-- 第二 -->
        <a-row class="margin-t-40">
          <a-col :span="24">
            <hm-img type="images" imgName="dilemma02" imgClass="introduction_img_style" align="left"/>
          </a-col>
          <a-col :span="24" class="info-box">
            <h1 class="info-title">持续提升税务合规</h1>
            <div class="introduce_info">
              <div class="QAIcon">
                <hm-img type="icons" imgName="Q" imgClass="QAImg"/>
              </div>
              <p>税务合规盲点可能给企业带来不确定的隐性成本，进而导致不可预估的经营资质和持久发展风险</p>
            </div>
            <a-divider />
            <div class="introduce_info">
              <div class="QAIcon">
                <hm-img type="icons" imgName="A" imgClass="QAImg"/>
              </div>
              <p>税纪云协助企业深入理解全球税务法规在经营中的应用，并通过信息化手段加强税务管理体系，快速遵从金税四期的变化与调整</p>
            </div>
          </a-col>
        </a-row>
        <!-- 第三 -->
        <a-row class="margin-t-40">
          <a-col :span="24">
            <hm-img type="images" imgName="dilemma03" imgClass="introduction_img_style" align="right"/>
          </a-col>
          <a-col :span="24" class="info-box">
            <h1 class="info-title">助力税务集中共享转型</h1>
            <div class="introduce_info">
              <div class="QAIcon">
                <hm-img type="icons" imgName="Q" imgClass="QAImg"/>
              </div>
              <p>数据核对与转换、报表准备等日常工作占用财税人员大量精力，使其难以投入到更高价值的管控与规划工作中，无法充分释放人员专业价值</p>
            </div>
            <a-divider />
            <div class="introduce_info">
              <div class="QAIcon">
                <hm-img type="icons" imgName="A" imgClass="QAImg"/>
              </div>
              <p>税纪云可自动高效处理各类税务事宜，显著减少人工参与，大幅提升税务处理效率，为企业节省人力成本</p>
            </div>
          </a-col>
        </a-row>
        <!-- 第四 -->
        <a-row class="margin-t-40">
          <a-col :span="24">
            <hm-img type="images" imgName="dilemma04" imgClass="introduction_img_style" align="left"/>
          </a-col>
          <a-col :span="24" class="info-box">
            <h1 class="info-title">AI助力提升专业能力</h1>
            <div class="introduce_info">
              <div class="QAIcon">
                <hm-img type="icons" imgName="Q" imgClass="QAImg"/>
              </div>
              <p>法规政策多变、各地实操差异大，对人员专业能力构成持续挑战</p>
            </div>
            <a-divider />
            <div class="introduce_info">
              <div class="QAIcon">
                <hm-img type="icons" imgName="A" imgClass="QAImg"/>
              </div>
              <p>全国税收政策法规库、税务领域专业ChatGPT应用，帮助财税人员实时掌握最新政策法规动态、高效规划专业税务解决方案</p>
            </div>
          </a-col>
        </a-row>
      </div>
    </div>
  </div>
</template>
  
  <script>
  import { mapGetters } from 'vuex'

  export default {
    name: '',
    props: {},
    components: {},
    data () {
      return {
       
      }
    },
    computed: {
    ...mapGetters(['isH5'])
  },
    created () {
  
    },
    methods: {
      
    }
  }
  </script>

  <style scoped lang='less'>
  .top-warp {
    background-image: linear-gradient(180deg, #fff, #F7F9FB);
    padding-bottom: 40PX;
    .dilemma-box {
      .margin-t-40 {
        margin-top: 40PX;
      }
      // width: 1200PX;
      // margin: 0 auto;
      padding: 0 2rem;
      .top-title {
        font-size: 20PX;
        color: #292F3A;
        letter-spacing: 0.1rem;
        text-align: center;
        line-height: 3rem;
        font-weight: 600;
        margin-bottom: 2rem;
        padding: 4rem 0;
        width: 53%;
        margin: 0 auto;
        position: relative;
        .bgDot-box {
          position: absolute;
          right: -0.2rem;
          top: 62px;
        }
      }
      .info-title {
        font-size: 16PX;
        color: #263D76;
        letter-spacing: 0;
        text-align: center;
        line-height: 20PX;
        font-weight: 600;
      }
      .introduce_info {
        margin-top: 32PX;
        .QAIcon {
          display: inline-block;
          vertical-align: top;
        }
        p {
          margin-left: 8PX;
          width: 90%;
          display: inline-block;
          font-size: 14PX;
          color: #292F3A;
          letter-spacing: 0;
          line-height: 28PX;
          font-weight: 400;
        }
      }
      .info-box {
        padding-top: 24PX;
      }
      .info-box.even {
        padding-left: 80PX;
        .introduce_info {
          p {
            width: 90%;
          }
        }
      }
    }
  }
  
  
  </style>

  
<style>
.QAImg {
    width: 18PX;
    margin-top: 4PX;
  }
.introduction_img_style {
  max-width: 564PX;
  width: 100%;
}
.bgDot {
  width: 16PX;
}
</style>


// WEBPACK FOOTER //
// src/views/home/components/tax-dilemma-h5.vue